// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BulkAltButton = registerClientReference(
    function() { throw new Error("Attempted to call BulkAltButton() from the server but BulkAltButton is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/media/_form.tsx",
    "BulkAltButton",
);
export const MediaCard = registerClientReference(
    function() { throw new Error("Attempted to call MediaCard() from the server but MediaCard is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/media/_form.tsx",
    "MediaCard",
);
export const UploadForm = registerClientReference(
    function() { throw new Error("Attempted to call UploadForm() from the server but UploadForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/app/admin/media/_form.tsx",
    "UploadForm",
);
